module.exports = __webpack_public_path__ + "img/cloud-music.5673a6dc.svg";